import { render, staticRenderFns } from "./InformationBanner.vue?vue&type=template&id=4d6f2487&scoped=true&"
import script from "./InformationBanner.vue?vue&type=script&lang=js&"
export * from "./InformationBanner.vue?vue&type=script&lang=js&"
import style0 from "./InformationBanner.vue?vue&type=style&index=0&id=4d6f2487&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6f2487",
  null
  
)

export default component.exports